import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { CustomerDetail } from "@/features/admin/customers/detail";
import { maskSearchFragment } from "@/features/shared/route-masking";

const searchSchema = z.object({
  "main-tab": z.string().optional(),
  "customer-aside": z.string().optional(),
  "customer-detail-id": z.string().optional(),
  "member-id": z.string().optional(),
  "place-id": z.string().optional(),
  "subscription-id": z.string().optional(),
  "payment-id": z.string().optional(),
  "wallet-transaction-id": z.string().optional(),
  "user-id": z.string().optional(),
  ...maskSearchFragment,
});

export const Route = createFileRoute("/admin/customers/$customerId")({
  validateSearch: searchSchema,
  component: CustomerDetail,
});
